// src/services/athleteExercisesService.ts
import axios from '../utils/axiosConfig';

import logger from '../utils/logger';

// Define interfaces
export interface AthleteExercise {
  athlete: string;
  exercise: string;
}

export interface AthleteExercisesMap {
  [athleteId: string]: string;
}

const athleteExercisesService = {
  // Get exercise for a specific athlete
  getExerciseForAthlete: async (
    competitionId: string,
    clubId: string,
    athleteId: string
  ): Promise<string> => {
    try {
      const response = await axios.get(
        `/api/athlete-exercises/${competitionId}/${clubId}/athlete/${athleteId}`
      );
      return response.data.exercise;
    } catch (error) {
      //console.error('Error fetching athlete exercise:', error);
      logger.error('Error fetching athlete exercise', { error: error });
      throw error;
    }
  },

  // Get all exercises for all athletes in a competition and club
  getAllExercises: async (
    competitionId: string,
    clubId: string
  ): Promise<AthleteExercisesMap> => {
    try {
      const response = await axios.get(
        `/api/athlete-exercises/${competitionId}/${clubId}`
      );
      return response.data;
    } catch (error) {
      //console.error('Error fetching all athlete exercises:', error);
      logger.error('Error fetching all athlete exercises', { error: error });
      throw error;
    }
  },

  // Save exercise for a specific athlete
  saveExerciseForAthlete: async (
    competitionId: string,
    clubId: string,
    athleteId: string,
    exercise: string
  ): Promise<void> => {
    try {
      await axios.post(
        `/api/athlete-exercises/${competitionId}/${clubId}/athlete/${athleteId}`,
        { exercise }
      );
    } catch (error) {
      //console.error('Error saving athlete exercise:', error);
      logger.error('Error saving athlete exercise', { error: error });
      throw error;
    }
  },

  // Delete exercise for a specific athlete
  deleteExerciseForAthlete: async (
    competitionId: string,
    clubId: string,
    athleteId: string
  ): Promise<void> => {
    try {
      await axios.delete(
        `/api/athlete-exercises/${competitionId}/${clubId}/athlete/${athleteId}`
      );
    } catch (error) {
      //console.error('Error deleting athlete exercise:', error);
      logger.error('Error deleting athlete exercise', { error: error });
      throw error;
    }
  }
};

export default athleteExercisesService;